import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { WorkTeamsDeleteDialog } from 'pages/Finance/WorkTeams/components/WorkTeamsDeleteDialog';
import { RaRecord, useEditController } from 'react-admin';
import { CancelButton, DeleteButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Permission } from 'types/embedded/permission';
import { WorkTeam } from 'types/embedded/workTeam';

import { BoxStyled } from './WorkTeamsEdit.styled';
import { WorkTeamsEditForm } from './WorkTeamsEditForm';

export const WorkTeamsEdit = () => {
  const { hasResourcePermissions } = usePermissions();
  const { record } = useEditController();

  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<WorkTeam>();

  return (
    <>
      <EditGuesserPage
        leftActionsSlot={
          hasResourcePermissions(Resources.WorkTeams, [Permission.Full, Permission.Delete]) ? (
            <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
          ) : undefined
        }
        listName="Рабочие группы"
        mutationOptions={{ onError: () => undefined }}
        open={!openRecordModalDelete}
        rightActionsSlot={[
          <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
          <SaveButtonValidated key="save-button" label="Сохранить" />,
        ]}
        title="Редактирование рабочей группы"
        transform={(data: RaRecord) => {
          return {
            ...data,
            reddyChatId: data?.reddyChatId ? Number(data?.reddyChatId) : null,
          };
        }}
      >
        <BoxStyled>
          <WorkTeamsEditForm />
        </BoxStyled>
      </EditGuesserPage>
      {openRecordModalDelete && (
        <WorkTeamsDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        />
      )}
    </>
  );
};
